<template>
  <svg
    id="square-foot-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="100 -835 720 750"
  ><path d="M208-120q-37 0-62.5-25.5T120-208v-548q0-29 27-40.5t47 8.5l90 90-54 54 28 28 54-54 104 104-54 54 28 28 54-54 104 104-54 54 28 28 54-54 104 104-54 54 28 28 54-54 80 80q20 20 8.5 47T756-120H208Zm32-120h332L240-572v332Z" />
  </svg>
</template>

<script>
export default {
  name: 'SquareFootIcon',
};
</script>

